import { ChangeEvent, useEffect, useRef, useState } from "react";
import { useUserInfor } from "../../../../../../../Context/User";
import {
    AtualizarConfigGeralController,
    CadastrarMensagemTransferenciaController,
    ListarMensagemTransferenciaController,
} from "../../../../../../../Controllers/Geral/GestaoDeCadastros/ConfigGeral/ConfigGeralController";
import useAsyncCallback from "../../../../../../../hooks/useAsyncCallback";
import UnForm from "../../../../../../Form";
import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
export default function AtendimentoWhatsappConfig() {
    const { Config, updateConfig, OrgInfor, UserInfor } = useUserInfor();
    const config = Config.ConfigAtendimentoDTO;
    const [inputText, setInputText] = useState("");
    const [showInput, setShowInput] = useState(false);
    const mensagemInicialRef = useRef<string>();
    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        setInputText(event.target.value);
    };
    const handleCheckboxChange = () => {
        setShowInput(!showInput);
        setInputText("");
    };
    const {
        value: lstMensagemTransferencia,
        execute: ListarMensagemTransferencia,
    } = useAsyncCallback(ListarMensagemTransferenciaController);
    const {
        execute: CadastrarMensagemTransferencia,
        loading: CadastrarMensagemTransferenciaLoading,
    } = useAsyncCallback(CadastrarMensagemTransferenciaController);
    const handleSendButtonClick = () => {
        CadastrarMensagemTransferencia({
            DS_MENSAGEM_TRANSFERENCIA: inputText,
            ID_ORGANIZACAO: OrgInfor.ID_ORGANIZACAO,
            ID_USUARIO_ALTERACAO: UserInfor.ID_USUARIO ?? 0,
        }).then(() => {
            ListarMensagemTransferencia();
        });
    };
    function update() {
        AtualizarConfigGeralController({
            ...Config,
            ConfigAtendimentoDTO: {
                ...config,
            },
        }).then(() => {
            updateConfig();
        });
    }
    useEffect(() => {
        if (showInput) {
            ListarMensagemTransferencia();
        }
    }, [ListarMensagemTransferencia, showInput]);
    useEffect(() => {
        if (lstMensagemTransferencia) {
            mensagemInicialRef.current =
                lstMensagemTransferencia.DS_MENSAGEM_TRANSFERENCIA;
            setInputText(lstMensagemTransferencia.DS_MENSAGEM_TRANSFERENCIA);
        }
    }, [lstMensagemTransferencia]);
    return (
        <UnForm handleSubmit={() => {}}>
            <div className="col-12 mb-4">
                <h4>Exibir primeiro nome</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Exibir o primeiro nome do atendente e do cliente no
                        Histórico das Interações
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={config?.FL_MOSTRAR_NOME_ATENDENTE}
                                    onChange={() => {
                                        config.FL_MOSTRAR_NOME_ATENDENTE =
                                            !config.FL_MOSTRAR_NOME_ATENDENTE;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <div className="col-12 mb-4">
                <h4>Personalizar Texto</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Personalizar o texto ou manter a mensagem padrão
                    </label>
                    <div className="col-12 d-flex align-items-center">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={showInput}
                                    onChange={handleCheckboxChange}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                        {showInput && (
                            <div className="d-flex flex-row align-items-center">
                                <UnForm.Input
                                    name="DS_MENSAGEM_TRANSFERENCIA"
                                    type="text"
                                    value={inputText}
                                    onChange={handleInputChange}
                                    placeholder={"Digite o texto aqui..."}
                                    defaultValue={mensagemInicialRef.current}
                                    className="form-control placeholder-dark-75 ml-2"
                                    style={{ width: "400px" }}
                                />
                                <UnForm.SubmitButton
                                    color="success"
                                    icon={faPaperPlane}
                                    onClick={handleSendButtonClick}
                                    className={`btn ml-2`}
                                    disabled={
                                        CadastrarMensagemTransferenciaLoading
                                    }
                                    loading={
                                        CadastrarMensagemTransferenciaLoading
                                    }
                                    loadingSize="sm"
                                >
                                    Enviar
                                </UnForm.SubmitButton>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className="col-12 mb-4">
                <h4>Pesquisa Satisfação</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Realizar Pesquisa de Satisfação via chat
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={
                                        config?.FL_PESQUISA_SATISFACAO_SIMPLIFICADA
                                    }
                                    onChange={() => {
                                        config.FL_PESQUISA_SATISFACAO_SIMPLIFICADA =
                                            !config.FL_PESQUISA_SATISFACAO_SIMPLIFICADA;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <div className="col-12 mb-4">
                <h4>Envio de áudio</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Disponibilizar o envio de áudio no atendimento WhatsApp
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={config?.FL_ENVIO_AUDIO_HELPDESK}
                                    onChange={() => {
                                        config.FL_ENVIO_AUDIO_HELPDESK =
                                            !config.FL_ENVIO_AUDIO_HELPDESK;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
            <div className="col-12 mb-4">
                <h4>Finalizar chat</h4>
                <div className="d-flex flex-column">
                    <label className="col-12 col-form-label px-0">
                        Permitir o cliente finalizar o atendimento com o comando
                        #SAIR ?
                    </label>
                    <div className="col-12">
                        <span className="switch switch-outline switch-icon switch-success">
                            <label>
                                <input
                                    type="checkbox"
                                    checked={config?.FL_FINALIZAR_CHAT}
                                    onChange={() => {
                                        config.FL_FINALIZAR_CHAT =
                                            !config.FL_FINALIZAR_CHAT;
                                        update();
                                    }}
                                    name="select"
                                />
                                <span></span>
                            </label>
                        </span>
                    </div>
                </div>
            </div>
        </UnForm>
    );
}
